import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import { API_HELPER } from "@/helpers/api.js";
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import moment from 'moment';
import VueMoment from 'vue-moment';

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueMoment, { moment }); // Necessary for chart.js

router.beforeEach((to, from, next) => {
  // cancel pending requests and reset controller
  API_HELPER.abortController.abort();
  API_HELPER.abortController = new AbortController();

  // if logged out, process request
  const logoutPages = ['/logout'];
  if (logoutPages.includes(to.path)) {
    store.dispatch('account/logout', null, { root: true });
    return;
  }

  const loggedIn = localStorage.getItem('user');
  const publicPages = ['/login'];

  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  // redirect to dashboard to dashboard if logged in and trying to acess logged out pages
  const authNotRequired = publicPages.includes(to.path);
  if (authNotRequired && loggedIn) {
    return next('/');
  }

  next();
})

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
